export default function CTASection() {
  return (
    <section className="relative w-full min-h-[500px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elevated%20aerial%20flat%20lay%20of%20curated%20fashion%20essentials%20sneakers%20accessories%20and%20leather%20goods%20surrounded%20by%20lush%20green%20monstera%20leaves%20and%20dried%20pampas%20grass%20on%20textured%20beige%20linen%20surface%20overhead%20editorial%20shot%20with%20soft%20diffused%20studio%20light%20organic%20natural%20aesthetic%20calming%20earthy%20tones&width=1800&height=1000&seq=cta-bg-v2-unique&orientation=landscape"
          alt="Kakobuy spreadsheet - organized shopping"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 text-center px-6 max-w-3xl mx-auto">
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight tracking-tight">
          Get The Full Kakobuy Spreadsheet
        </h2>
        <p className="mt-4 text-base md:text-lg text-background-50/80 font-light max-w-xl mx-auto">
          Organized categories. Verified products. Safer shopping. Access the complete spreadsheet with all 14 categories and 500+ curated finds.
        </p>
        <div className="mt-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center gap-3 px-10 py-5 rounded-full bg-primary-500 text-background-50 text-lg font-bold hover:bg-primary-600 transition-all duration-200 cursor-pointer group"
          >
            <i className="ri-shopping-bag-line text-xl"></i>
            <span>Buy It Now</span>
            <i className="ri-arrow-right-up-line text-xl group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
          </a>
        </div>
      </div>
    </section>
  );
}